export const AUTH_PRODUCT_LIST = ['Модус', 'Визор', 'Юнион', 'Купол', 'Сфера', 'DION'];
